
export function setPaymentMethods(state, paymentMethods){
    state.paymentMethods = paymentMethods;
}
export function setSelectedModel(state, selectedModel){
    state.selected_model= selectedModel;
}

export function modalPaymentMethodsToggle(state, from_inventory_documents = false) {
    state.show.modal_component = !state.show.modal_component;
    state.from_inventory_documents = from_inventory_documents
}
export function CloseModalPaymentMethodsToggle(state) {
    state.show.modal_component = false;
}
export async function validationsModalPaymentMethods(state) {
    // Eliminamos los registros vacios
    let voidModalPaymentMethods = state.data.filter(
        d =>
            !d.payment_method_id &&
            !d.authorization_number &&
            !d.check_number &&
            !d.entity &&
            !d.value
    );

    await Promise.all(
        voidModalPaymentMethods.map(d => {
            deleteRowModalPaymentMethodsData(state, d.id);
        })
    );

    if (state.selected_model.handle_payment_methods === 9) {
        if (state.data.length <= 0) {
            return false;
        }
    }
}
export function deleteRowModalPaymentMethodsData(state, id) {
    let index = state.data.findIndex(d => d.id === id);
    state.data.splice(index, 1);
}
export function resetModalPaymentMethodsData(state) {
    state.data = [];
}

export function setSelectedDocument(state, selected_document) {
    //productos con promo
    selected_document.documents_products.map((dp) => {
        if (dp.promotion) {
            dp.applied_promotion = dp.promotion.description;
        }
    });

    state.selected_document = selected_document;
}


export function setloading(state, value) {
    state.loading = value;
}
export function setPaymentMethodsSend(state,paymentMethodsSend) {
    state.paymentMethodsSend = paymentMethodsSend;
}
export function setCompleteProcess(state, value) {
    state.complete = value;
}

/**
 * Establecer un valor para la variable data.
 */
export function setData(state, data) {
    state.data = data;
}

/**
 * Establecer un valor para la variable balance.
 */
export function setBalance(state, balance) {
    state.balance = +balance;
}

export function setFromAccountingDocuments(state,from_accounting_documents) {
    state.from_accounting_documents = from_accounting_documents;
}


// WEBPACK FOOTER //
// ./src/modules/payments-methods-modal/mutations.js